/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React, { useState, useEffect, useRef } from "react";
import { Card, Row, Col, message, Button } from "antd";

import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    DropDownComponent,
    TableComponent,
    CalendarComponent,
    RefreshTimestamp
} from "../../CommonComponents";
import "../styles.scss";
import Heading from "../../../../components/Heading";
import { getHubList, getHubCPList } from "../../../../services/api/hub";
import { ReportsService } from "../../../../services/api/reports";
import { downloadControlTowerHubReport } from "../../../../utils/downloadUtils";
import { useNavigate } from "react-router-dom";
import { useRequestCancellation } from "../../../../hooks/useRequestCancellation";
import { SHIPMENT_STATUS_LIST, getStatusDisplayText, STATUS_DISPLAY_MAP } from "../../../../constants/shipmentStatus";

// Custom status list for Outgoing Shipment Report
const OUTGOING_SHIPMENT_STATUS_LIST = [
    { value: "SORTED", label: "Sorted" },
    { value: "HUB-OUTSCAN", label: "Hub Outscan" },
    { value: "HUB-IN-SCANNED", label: "Hub In-Scanned" },
    { value: "OUT_SCAN_TO_CP", label: "Out Scan to CP" },
    { value: "MANIFESTED_FOR_CP", label: "Manifested for CP" },
    { value: "INSCANNED_AT_CP", label: "Inscanned at CP" },
    { value: "DRSGENERATED", label: "DRS Generated" },
    { value: "OUT_FOR_DELIVERY", label: "Out for Delivery" },
    { value: "DELIVERED", label: "Delivered" },
    { value: "DELIVERY_FAILED", label: "Delivery Failed" },
    { value: "DESTROYED", label: "Destroyed" },
    { value: "RETURN_INITIATED", label: "Return Initiated" },
    { value: "RETURN_DELIVERED", label: "Return Delivered" },
    { value: "RTO_DELIVERED", label: "RTO Delivered" },
    { value: "CF_NEXT_DAY", label: "CF Next Day" },
    { value: "RETURN", label: "Return" },
    { value: "INSCANNED_AT_TRANSIT", label: "Inscanned at Transit" },
    { value: "BAGGED", label: "Bagged" },
    { value: "EXCESS_INSCAN", label: "Excess Inscan" },
    { value: "UPDATED_BOOKING", label: "Updated Booking" },
    { value: "BAG_CREATED", label: "Bag Created" },
    { value: "BAG_FINALISED", label: "Bag Finalised" },
    { value: "LCR-INSCAN", label: "LCR Inscan" },
    { value: "BAG_DELETED", label: "Bag Deleted" },
    { value: "DAMAGED", label: "Damaged" },
    { value: "TERMINATED", label: "Terminated" },
    { value: "MIS_ROUTED", label: "Mis Routed" },
    { value: "DISCARDED", label: "Discarded" },
    { value: "REROUTED", label: "Rerouted" },
    { value: "REMOVED_FROM_LCR", label: "Removed from LCR" },
    { value: "PINCODE_AUDITED", label: "Pincode Audited" },
    { value: "MODE_AUDITED", label: "Mode Audited" },
    { value: "WEIGHT_AUDITED", label: "Weight Audited" },
    { value: "RETURN_REVOKED", label: "Return Revoked" },
    { value: "IN-BAG-INSCAN", label: "In-Bag Inscan" },
    { value: "IN-BAG-OUTSCAN", label: "In-Bag Outscan" },
    { value: "FORCE_BAG", label: "Force Bag" },
    { value: "ATTEMPTED", label: "Attempted" },
    { value: "RTO_OUT_FOR_DELIVERY", label: "RTO Out for Delivery" },
    { value: "FORCE_OUTSCAN_TO_CP", label: "Force Outscan to CP" },
    { value: "IN_BAG_OUTSCAN_TO_CP", label: "In Bag Outscan to CP" },
    { value: "FORCE_HUB_OUTSCAN", label: "Force Hub Outscan" },
    { value: "IN_BAG_OUTSCAN_TO_3PL", label: "In Bag Outscan to 3PL" },
    { value: "OUT_SCAN_TO_DP", label: "Out Scan to DP" },
    { value: "OUT_SCAN_TO_3PL", label: "Out Scan to 3PL" },
    { value: "FORCE_BAG_ATTEMPTED", label: "Force Bag Attempted" },
    { value: "UNDELIVERED", label: "Undelivered" },
    { value: "SCHEDULED_FOR_TRIP", label: "Scheduled for Trip" }
];
import {
    SERVICE_TYPE_OPTIONS,
    BOOKING_TYPE_OPTIONS,
    DOCUMENT_TYPE_OPTIONS,
    REPORT_FILTER_LABELS,
    REPORT_PLACEHOLDERS
} from "../../../../constants/reportConstants";
import { useCopilotReadable } from "@copilotkit/react-core";

const OutgoingShipmentReport = () => {
    const { createNewRequest, isLatestRequest } = useRequestCancellation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [dateRange, setDateRange] = useState([
        moment().subtract(0, "days"),
        moment()
    ]);
    const [hubList, setHubList] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState([]);
    const [cpList, setCpList] = useState([]);
    const [selectedDestinationHub, setSelectedDestinationHub] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [selectedServiceType, setSelectedServiceType] = useState([]);
    const [selectedBookingType, setSelectedBookingType] = useState([]);
    const [selectedDocumentType, setSelectedDocumentType] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);
    const [headerHubList, setHeaderHubList] = useState([]);
    const [hubUser, setHubUser] = useState();
    const [lastsynced, setLastsynced] = useState(null);
    const [nextScheduledRefresh, setNextScheduledRefresh] = useState(null);
    const [activeHubId, setActiveHubId] = useState(JSON.parse(localStorage.getItem("active_hub") || "{}")?.hubId || "ALL_HUBS");

    // Fetch hubs from header/localStorage
    useEffect(() => {
        try {
            const userFullData = JSON.parse(localStorage.getItem("userId") || "{}");
            const userHubs = userFullData?.userInfo?.hubDetails || [];
            if (userHubs?.length > 0) {
                const headerHubs = [
                    { label: "All", value: "ALL" },
                    ...userHubs.map(hub => ({
                        label: hub.hubName,
                        value: hub.hubId
                    }))
                ];
                setHeaderHubList(headerHubs);
            } else {
                // If no hubs assigned, show all available hubs but without "All" option
                setHeaderHubList([]);
            }
        } catch (e) {
            console.error("Error parsing user hubs for Outgoing Shipment Report", e);
            setHeaderHubList([]);
        }
    }, []);

    const handleMultiSelectChange = (values, setter, options = []) => {
        if (values.includes("ALL")) {
            const isLatestAll = values[values.length - 1] === "ALL";
            if (isLatestAll) {
                const allActualValues = options
                    .filter(opt => opt.value !== "ALL")
                    .map(opt => opt.value);
                setter(allActualValues);
            } else {
                setter(values.filter(v => v !== "ALL"));
            }
        } else {
            setter(values);
        }
    };

    // Make report data available to CopilotKit
    useCopilotReadable({
        description: "Outgoing Shipment Report data including filters, results, and analytics",
        value: {
            reportType: "Outgoing Shipment Report",
            reportData: {
                totalRecords: pagination.total,
                currentPage: pagination.current,
                pageSize: pagination.pageSize,
                recordsShown: reportData.length,
                data: reportData.slice(0, 10).map(item => ({
                    awbNumber: item.awbNumber,
                    bookingDate: item.bookingDate,
                    status: item.status,
                    originHub: item.originHub,
                    destinationHub: item.destinationHub,
                    serviceType: item.serviceType,
                    bookingType: item.bookingType,
                    documentType: item.documentType
                }))
            },
            appliedFilters: {
                dateRange: dateRange ? {
                    startDate: dateRange[0]?.format("YYYY-MM-DD"),
                    endDate: dateRange[1]?.format("YYYY-MM-DD")
                } : null,
                selectedHubs: selectedHubs,
                selectedDestinationHub: selectedDestinationHub,
                selectedStatus: selectedStatus,
                selectedServiceType: selectedServiceType,
                selectedBookingType: selectedBookingType,
                selectedDocumentType: selectedDocumentType
            },
            availableOptions: {
                hubList: hubList.map(hub => ({ value: hub.value, label: hub.label })),
                statusOptions: OUTGOING_SHIPMENT_STATUS_LIST,
                serviceTypeOptions: SERVICE_TYPE_OPTIONS,
                bookingTypeOptions: BOOKING_TYPE_OPTIONS,
                documentTypeOptions: DOCUMENT_TYPE_OPTIONS
            },
            reportMetrics: {
                loading: loading,
                downloadLoading: downloadLoading,
                userRole: hubUser,
                lastUpdated: new Date().toISOString()
            }
        }
    });

    // Fetch hub list on mount
    useEffect(() => {
        (async () => {
            try {
                setLoading(true);
                const hubs = await getHubList();
                const userFullData = JSON.parse(localStorage.getItem("userId") || "{}");
                const userHubs = userFullData?.userInfo?.hubDetails || [];

                let hubOptions;
                if (userHubs?.length > 0) {
                    hubOptions = [
                        { label: "All", value: "ALL" },
                        ...hubs
                    ];
                } else {
                    hubOptions = hubs;
                }
                setHubList(hubOptions);
            } catch {
                message.error("Failed to fetch hub list");
            } finally {
                setLoading(false);
            }
        })();
    }, []);
    // Ref to track whether we already set the hub for the current login session
    const hubInitializedRef = useRef(false);

    useEffect(() => {
        const handleHubChanged = () => {
            const activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
            const newActiveHubId = activeHub?.hubId;
            setActiveHubId(newActiveHubId || "ALL_HUBS");
            if (newActiveHubId && newActiveHubId !== "ALL_HUBS") {
                setSelectedHubs([newActiveHubId]);
            } else {
                setSelectedHubs(["ALL"]);
            }
        };

        window.addEventListener("hubChanged", handleHubChanged);
        return () => window.removeEventListener("hubChanged", handleHubChanged);
    }, []);

    // Set default hub based on logged-in user — always enforced for hub-restricted roles
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userinfo") || "{}");
        const userid = JSON.parse(localStorage.getItem("userId") || "{}");
        const role = user?.roles?.[0];
        setHubUser(role);

        const activeHub = JSON.parse(localStorage.getItem("active_hub") || "{}");
        const currentActiveHubId = activeHub?.hubId || "ALL_HUBS";

        if (!hubInitializedRef.current) {
            const userFullData = JSON.parse(localStorage.getItem("userId") || "{}");
            const userHubs = userFullData?.userInfo?.hubDetails || [];

            if (currentActiveHubId && currentActiveHubId !== "ALL_HUBS") {
                setSelectedHubs([currentActiveHubId]);
            } else if (userHubs?.length === 0 || role === "ROLE_HOADMIN" || role === "ROLE_CENTRALOPERATOR") {
                setSelectedHubs([]);
            } else {
                setSelectedHubs(["ALL"]);
            }
            hubInitializedRef.current = true;
        }
    }, [headerHubList]); // Depend on headerHubList to ensure we have options available


    // Fetch report data when filters or pagination change
    useEffect(() => {
        // Wait for hubUser to be initialized
        if (!hubUser) {
            return;
        }

        // Don't fetch if no hubs are selected
        if (selectedHubs.length === 0 && (hubUser == "ROLE_HUBADMIN" || hubUser == "ROLE_HUBOPERATOR")) {
            return;
        }

        // Guard against invalid dateRange
        if (!dateRange || !dateRange[0] || !dateRange[1]) {
            return;
        }

        console.log("Control Tower Hub Report - Fetching with pagination:", {
            current: pagination.current,
            pageSize: pagination.pageSize,
            selectedHubs,
            dateRange
        });

        fetchReport();
        // eslint-disable-next-line
    }, [hubUser, selectedHubs, selectedDestinationHub, selectedStatus, selectedServiceType, selectedBookingType, selectedDocumentType, dateRange, pagination.current, pagination.pageSize]);

    const fetchReport = async () => {
        // Guard against invalid dateRange
        if (!dateRange || !dateRange[0] || !dateRange[1]) {
            return;
        }

        // 🔥 CREATE NEW REQUEST WITH GLOBAL HOOK
        const { signal, requestId } = createNewRequest("outgoing-shipment-report");

        try {
            setLoading(true);
            setReportData([]); // Clear previous data

            // Resolve Origin Hubs for API logic
            const isSpecialRole = hubUser === "ROLE_HOADMIN" || hubUser === "ROLE_CENTRALOPERATOR";
            const activeHubOptions = isSpecialRole ? hubList : (headerHubList?.length > 0 ? headerHubList : hubList);
            const resolvedOriginHubs = selectedHubs?.includes("ALL")
                ? activeHubOptions.filter(opt => opt.value !== "ALL").map(opt => opt.value)
                : selectedHubs;

            const hasAllDestination = selectedDestinationHub?.includes("ALL");
            const hasAllStatus = selectedStatus?.includes("ALL");
            const hasAllService = selectedServiceType?.includes("ALL");
            const hasAllBooking = selectedBookingType?.includes("ALL");
            const hasAllDocument = selectedDocumentType?.includes("ALL");

            const params = {
                ...(resolvedOriginHubs?.length > 0 && { originHubId: resolvedOriginHubs.join(",") }),
                ...(!hasAllDestination && selectedDestinationHub?.length > 0 && { destinationHubId: selectedDestinationHub.filter(id => id !== "ALL").join(",") }),
                ...(dateRange[0] && dateRange[1] && {
                    fromDate: dateRange[0].format("YYYY-MM-DD"),
                    toDate: dateRange[1].format("YYYY-MM-DD")
                }),
                ...(!hasAllStatus && selectedStatus?.length > 0 && { currentStatus: selectedStatus.filter(s => s !== "ALL").join(",") }),
                ...(!hasAllService && selectedServiceType?.length > 0 && { serviceType: selectedServiceType.filter(s => s !== "ALL").join(",") }),
                ...(!hasAllBooking && selectedBookingType?.length > 0 && { bookingType: selectedBookingType.filter(s => s !== "ALL").join(",") }),
                ...(!hasAllDocument && selectedDocumentType?.length > 0 && { documentType: selectedDocumentType.filter(s => s !== "ALL").join(",") }),
                page: (pagination.current - 1), // Convert to 0-based
                size: pagination.pageSize
            };

            // Call the control tower hub report API with signal
            const { data, total, lastRefreshedAt, nextScheduledRefresh } = await ReportsService.getControlTowerHubReport(params, { signal });

            // 🔥 ONLY UPDATE IF THIS IS THE LATEST REQUEST
            if (isLatestRequest(requestId)) {
                console.log(`🔥 Request ${requestId} completed successfully - updating state`);
                setReportData(data);
                setLastsynced(lastRefreshedAt);
                setNextScheduledRefresh(nextScheduledRefresh);
                setPagination(prev => ({
                    ...prev,
                    total,
                }));
            }

        } catch (error) {
            // 🔥 DON'T UPDATE STATE IF REQUEST WAS CANCELLED
            if (error.name === "AbortError") {
                console.log("🔥 Request was cancelled at HTTP level - no state update");
                return;
            }

            // Only update if this is still the latest request
            if (isLatestRequest(requestId)) {
                message.error("Failed to fetch report data");
                setReportData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0
                }));
            }
        } finally {
            // 🔥 ONLY UPDATE LOADING IF THIS IS THE LATEST REQUEST
            if (isLatestRequest(requestId)) {
                setLoading(false);
            }
        }
    };

    const handleTableChange = (newPagination) => {
        setPagination(prev => ({
            ...prev,
            current: newPagination.current,
            pageSize: newPagination.pageSize
        }));
    };

    // Custom handler for date range change
    const handleDateRangeChange = (value) => {
        setDateRange(value);
        // Do NOT clear reportData here!
    };

    const handleDownload = async () => {
        if (!dateRange || !dateRange[0] || !dateRange[1]) {
            message.error("Please select a date range for download");
            return;
        }

        setDownloadLoading(true);
        try {
            // Resolve Origin Hubs for Download logic
            const isSpecialRole = hubUser === "ROLE_HOADMIN" || hubUser === "ROLE_CENTRALOPERATOR";
            const activeHubOptions = isSpecialRole ? hubList : (headerHubList?.length > 0 ? headerHubList : hubList);
            const resolvedOriginHubs = selectedHubs?.includes("ALL")
                ? activeHubOptions.filter(opt => opt.value !== "ALL").map(opt => opt.value)
                : selectedHubs;

            const downloadParams = {
                ...(resolvedOriginHubs?.length > 0 && { originHubId: resolvedOriginHubs.join(",") }),
                ...(selectedDestinationHub?.length > 0 && { destinationHubId: selectedDestinationHub.filter(id => id !== "ALL").join(",") }),
                fromDate: dateRange[0].format("YYYY-MM-DD"),
                toDate: dateRange[1].format("YYYY-MM-DD"),
                ...(selectedStatus?.length > 0 && { currentStatus: selectedStatus.filter(id => id !== "ALL").join(",") }),
                ...(selectedServiceType?.length > 0 && { serviceType: selectedServiceType.filter(id => id !== "ALL").join(",") }),
                ...(selectedBookingType?.length > 0 && { bookingType: selectedBookingType.filter(id => id !== "ALL").join(",") }),
                ...(selectedDocumentType?.length > 0 && { documentType: selectedDocumentType.filter(id => id !== "ALL").join(",") })
            };

            await downloadControlTowerHubReport(downloadParams);
            message.success("Report downloaded successfully");
        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to download report");
        } finally {
            setDownloadLoading(false);
        }
    };

    // Table columns
    const columns = [
        {
            title: "Sr No.",
            dataIndex: "index",
            key: "index",
            width: 80,
            render: (_, __, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
        },
        {
            title: "AWB Number",
            dataIndex: "trackingId",
            key: "trackingId",
            sorter: true,
            width: 140,
            render: (text, record) => (
                <span
                    style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                    onClick={() => {
                        const url = `/shipment-tracker?awb=${text}`;
                        window.open(url, "_blank");
                    }}
                >
                    {text}
                </span>
            )
        },
        {
            title: "Operation DateTime",
            dataIndex: "bookingTime",
            key: "bookingTime",
            sorter: true,
            width: 140,
            render: (text) => text ? moment(text).format("DD-MM-YYYY HH:mm:ss") : "-"
        },
        {
            title: "Origin Hub",
            dataIndex: "originHubName",
            key: "originHubName",
            sorter: true,
            width: 160
        },
        {
            title: "Current Hub",
            dataIndex: "currentHubName",
            key: "currentHubName",
            sorter: true,
            width: 160
        },
        {
            title: "Destination Hub",
            dataIndex: "destinationHubName",
            key: "destinationHubName",
            sorter: true,
            width: 160
        },
        {
            title: "Doc Type",
            dataIndex: "docType",
            key: "docType",
            sorter: true,
            width: 100
        },
        {
            title: "Service Type",
            dataIndex: "serviceType",
            key: "serviceType",
            sorter: true,
            width: 100
        },
        {
            title: "Booking Type",
            dataIndex: "bookingType",
            key: "bookingType",
            sorter: true,
            width: 100
        },
        {
            title: "Mode",
            dataIndex: "mode",
            key: "mode",
            sorter: true,
            width: 100
        },
        {
            title: "Status",
            dataIndex: "currentStatus",
            key: "currentStatus",
            sorter: true,
            width: 100,
            render: (text) => getStatusDisplayText(text)
        }
    ];

    return (
        <div className="report-container">
            <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
                <Heading
                    title="Outgoing Shipment"
                    newReportUrl="/reports/outgoing/"
                >
                    <div style={{ paddingTop: "5px" }}>
                        <RefreshTimestamp
                            lastRefreshedAt={lastsynced}
                            nextScheduledRefresh={nextScheduledRefresh}
                        />
                    </div>
                </Heading>
            </div>
            <Card className="report-card">
                <Row gutter={[16, 16]} className="filters-section">
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">OperationTime</div>
                        <CalendarComponent
                            className="custom-calendar"
                            type="range"
                            value={dateRange && dateRange[0] && dateRange[1] ? dateRange : [moment(), moment()]}
                            onChange={handleDateRangeChange}
                            format="YYYY-MM-DD"
                            allowClear
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Origin Hub</div>
                        <DropDownComponent
                            placeholder="Origin Hub"
                            options={(hubUser === "ROLE_HOADMIN" || hubUser === "ROLE_CENTRALOPERATOR") ? hubList.filter(o => o.value !== "ALL") : (headerHubList?.length > 0 ? headerHubList : hubList)}
                            onChange={(val) => {
                                const baseOptions = (hubUser === "ROLE_HOADMIN" || hubUser === "ROLE_CENTRALOPERATOR") ? hubList.filter(o => o.value !== "ALL") : (headerHubList?.length > 0 ? headerHubList : hubList);
                                handleMultiSelectChange(val, setSelectedHubs, baseOptions);
                            }}
                            value={selectedHubs}
                            allowClear
                            mode="multiple"
                            maxTagCount={1}
                            maxTagPlaceholder={(omittedValues) => `... +${omittedValues.length}`}
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Destination Hub</div>
                        <DropDownComponent
                            placeholder="Destination Hub"
                            options={hubList.filter(hub => hub.value !== "ALL")}
                            onChange={(val) => handleMultiSelectChange(val, setSelectedDestinationHub, hubList)}
                            value={selectedDestinationHub}
                            allowClear
                            mode="multiple"
                            maxTagCount="responsive"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">Status</div>
                        <DropDownComponent
                            placeholder="Select Status"
                            options={OUTGOING_SHIPMENT_STATUS_LIST}
                            onChange={(val) => handleMultiSelectChange(val, setSelectedStatus, OUTGOING_SHIPMENT_STATUS_LIST)}
                            value={selectedStatus}
                            allowClear
                            mode="multiple"
                            maxTagCount="responsive"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">{REPORT_FILTER_LABELS.SERVICE_TYPE}</div>
                        <DropDownComponent
                            placeholder={REPORT_PLACEHOLDERS.SELECT_SERVICE_TYPE}
                            options={SERVICE_TYPE_OPTIONS.filter(opt => opt.value !== "ALL")}
                            onChange={(val) => handleMultiSelectChange(val, setSelectedServiceType, SERVICE_TYPE_OPTIONS.filter(opt => opt.value !== "ALL"))}
                            value={selectedServiceType}
                            allowClear
                            mode="multiple"
                            maxTagCount="responsive"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">{REPORT_FILTER_LABELS.BOOKING_TYPE}</div>
                        <DropDownComponent
                            placeholder={REPORT_PLACEHOLDERS.SELECT_BOOKING_TYPE}
                            options={BOOKING_TYPE_OPTIONS.filter(opt => opt.value !== "ALL")}
                            onChange={(val) => handleMultiSelectChange(val, setSelectedBookingType, BOOKING_TYPE_OPTIONS.filter(opt => opt.value !== "ALL"))}
                            value={selectedBookingType}
                            allowClear
                            mode="multiple"
                            maxTagCount="responsive"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <div className="filter-label">{REPORT_FILTER_LABELS.DOCUMENT_TYPE}</div>
                        <DropDownComponent
                            placeholder={REPORT_PLACEHOLDERS.SELECT_DOCUMENT_TYPE}
                            options={DOCUMENT_TYPE_OPTIONS.filter(opt => opt.value !== "ALL")}
                            onChange={(val) => handleMultiSelectChange(val, setSelectedDocumentType, DOCUMENT_TYPE_OPTIONS.filter(opt => opt.value !== "ALL"))}
                            value={selectedDocumentType}
                            allowClear
                            mode="multiple"
                            maxTagCount="responsive"
                            showSearch={true}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                                (option?.label || "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={6} style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                        <Button
                            type="primary"
                            icon={<DownloadOutlined />}
                            loading={downloadLoading}
                            onClick={handleDownload}
                            disabled={!dateRange || !dateRange[0] || !dateRange[1]}
                        >
                            Download Report
                        </Button>
                    </Col>
                </Row>
            </Card>
            <TableComponent
                columns={columns}
                dataSource={reportData}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                scroll={{ y: "calc(100vh - 300px)", x: "max-content" }}
                sticky
                rowKey="trackingId"
            />
        </div>
    );
};

export default OutgoingShipmentReport;
